<div #certificateContainer id="certificateContainer">
  <div class="watermark">HPCD</div>

  <div class="page" *ngIf="data?.amendments?.name &&
!data?.amendments?.address &&
!data?.amendments?.objectives &&
!data?.amendments?.rules &&
!data?.amendments?.area
">

    <div class="reg-barcode-section">

      <!-- <div class="reg-no">
      Registration No:
    </div>

   <ngx-barcode6
    [bc-format]="'CODE128'"
    [bc-value]="data?.regNo"
    [bc-display-value]="false"
    [bc-height]="40"
    [bc-width]="1.5">
  </ngx-barcode6> 
    <div>
       <img src="https://dummyimage.com/150x40/000/fff&text=|||||||||||||||" alt="Barcode" width="150"
                          height="40" style="margin-top: 5px; border: 0;"> 


      <b>{{data?.regNo}}</b>
    </div> -->
      <div class="reg-container">

        <!-- 🔹 Registration Label -->
        <div class="reg-label">
          <b> Registration No:</b>
        </div>

        <!-- 🔹 QR + Reg No -->
        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <!-- 🔹 Reg No below QR -->
          <div class="reg-value">
            <b>{{data?.regNo}}</b>
          </div>

        </div>

      </div>



    </div>

    <h2 class="title">Certificate of Registration of Amendment</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p class="mt-2"> हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the
      <b>{{ data?.amendments.oldName }}</b>
      (located at <b>{{ data?.address }}</b>)

      previously registered under the Societies Registration Act, 2006 by the
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>,

      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ' + data?.district
        }}
      </b>, Himachal Pradesh vide Registration No.
      <b>{{ data?.regNo }}</b> dated
      <b>{{ data?.regDate }}</b>

      has changed its Name to
      <b>{{ data?.amendments.newName }}</b>
      by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the said
      <b>{{ data?.amendments.newName }}</b>
      (located at {{ data?.address }})

      has now been Registered with the amended Name under sub section (2) of section
      11 of the Himachal Pradesh Societies Registration Act, 2006 (Act No. 25 of 2006)

      on the <span [innerHTML]="data?.amendDayText"></span>
      <b> ({{ data?.amendDate }})</b>.


    </p>
    <p class="content underline">
      <i> The Certificate issued previously vide No.
        <b>{{ data?.regNo }}</b> dated
        <b>{{ data?.regDate }}</b> shall be treated as cancelled.</i>
    </p>

    <p class="content">
      Given under my hand and seal at
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ' + data?.district
        }}
      </b>
      Himachal Pradesh.
    </p>
    <div class="footer">
      <div></div>
      <div>
        <p> <b>
            {{
            data?.iAreaOperation === 111
            ? 'Registrar of Societies'
            : data?.iAreaOperation === 112
            ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
            : data?.iAreaOperation === 113
            ? 'SDM -cum- Deputy Registrar of Societies'
            : 'Registrar of Societies'
            }}
          </b></p>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>




  </div>


  <div class="page" *ngIf="data?.amendments?.address &&
!data?.amendments?.name &&
!data?.amendments?.objectives &&
!data?.amendments?.rules &&
!data?.amendments?.area
                   ">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.regNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">
      Certificate of Registration of Amendment
    </h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the

      <b>{{ data?.societyName }}</b>

      ( located at
      {{ data?.amendments?.oldAddress }} )

      registered under the Societies Registration Act, 2006 by the

      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>,
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office, ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + data?.district
        }}
      </b>,

      Himachal Pradesh vide Registration No.

      <b>{{ data?.regNo }}</b>

      dated

      <b>{{ data?.regDate }}</b>

      has changed its Address to

      <b>{{ data?.amendments?.newAddress }}</b>

      by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the amendment in Address

      of Society has been Registered under the Himachal Pradesh Societies
      Registration Act, 2006 (Act No. 25 of 2006)

      on the

      <span [innerHTML]="data?.amendDayText"></span>

      ({{ data?.amendDate }}).

    </p>

    <p class="content">

      Given under my hand and seal at

      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office, ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + data?.district
        }}
      </b>,

      Himachal Pradesh.

    </p>

    <div class="footer">

      <div></div>

      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>

    </div>

  </div>


  <div class="page" *ngIf="data?.amendments?.objectives &&
!data?.amendments?.address &&
!data?.amendments?.name &&
!data?.amendments?.rules &&
!data?.amendments?.area
">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <!-- 🔹 Registration Label -->
        <div class="reg-label">
          <b> Registration No:</b>
        </div>

        <!-- 🔹 QR + Reg No -->
        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <!-- 🔹 Reg No below QR -->
          <div class="reg-value">
            <b>{{data?.regNo}}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Amendment</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the
      <b>{{ data?.societyName }}</b>

      (located at {{ data?.address }})

      registered under the Societies Registration Act, 2006 by the
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>,
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office, ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + 'Shimla'
        }}
      </b>, Himachal Pradesh vide Registration No.
      <b>{{ data?.regNo }}</b> dated
      <b>{{ data?.regDate }}</b>

      has changed its Objectives by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>
    <p class="content">

      It is further certified that the amendment in Objectives of Society has been Registered under the Himachal Pradesh
      Societies Registration Act, 2006 (Act No. 25 of 2006)

      on the
      <span [innerHTML]="data?.amendDayText"></span>
      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content">
      Given under my hand and seal at
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office, ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + data?.district
        }}
      </b>,
      Himachal Pradesh.
    </p>

    <div class="footer">
      <div></div>
      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>




  </div>

  <div class="page" *ngIf="data?.amendments?.rules &&
!data?.amendments?.address &&
!data?.amendments?.objectives &&
!data?.amendments?.name &&
!data?.amendments?.area">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.regNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Amendment</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the
      <b>{{ data?.societyName }}</b>

      ( located at <b>{{ data?.address }}</b> )

      registered under the Societies Registration Act, 2006 by the
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office, ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + data?.district
        }}
      </b>,
      Himachal Pradesh vide Registration No.
      <b>{{ data?.regNo }}</b>
      dated
      <b>{{ data?.regDate }}</b>

      has changed its Rules and Regulations

      by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the amendment in
      Rules and Regulations of Society

      has been Registered under the Himachal Pradesh Societies Registration Act, 2006
      (Act No. 25 of 2006)

      on the
      <span [innerHTML]="data?.amendDayText"></span>

      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content">
      Given under my hand and seal at
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office, ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + data?.district
        }}
      </b>,
      Himachal Pradesh.
    </p>

    <div class="footer">
      <div></div>

      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>

  </div>

  <div class="page" *ngIf="data?.amendments?.area &&
!data?.amendments?.address &&
!data?.amendments?.objectives &&
!data?.amendments?.rules &&
!data?.amendments?.name">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.newRegNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.regNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Societies</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
    </div>

    <p class="content">

      This is certified that the

      <b>{{ data?.societyName }}</b>

      (located at <b>{{ data?.address }}</b>)

      previously registered under the Societies Registration Act, 2006 by the

      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>,
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office, ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + data?.district
        }}
      </b>,

      vide Registration No.

      <b>{{ data?.regNo }}</b>

      dated

      <b>{{ data?.regDate }}</b>

      has extended its area of operation from

      <span>
        <b>
          {{
          data?.amendments.oldAreaLevel === 111
          ? 'State Level'
          : data?.amendments.oldAreaLevel === 112
          ? 'District Level'
          : data?.amendments.oldAreaLevel === 113
          ? 'Sub-Division Level'
          : ''
          }}</b>
        {{
        data?.amendments.oldAreaLevel == 111
        ? '(under Directorate of Cooperation, Shimla)'
        : data?.amendments.oldAreaLevel == 112
        ? '(under D.C. Office, ' + data?.district + ')'
        : data?.amendments.oldAreaLevel == 113
        ? '(under SDM Office, ' + data?.district + ')'
        : 'Directorate of Cooperation, ' + data?.district
        }}
      </span>

      to

      <span>
        <b>
          {{
          data?.amendments.newAreaLevel === 111
          ? 'State Level'
          : data?.amendments.newAreaLevel === 112
          ? 'District Level'
          : data?.amendments.newAreaLevel === 113
          ? 'Sub-Division Level'
          : ''
          }}
        </b>

        {{
        data?.amendments.newAreaLevel === 111
        ? ' (under Directorate of Cooperation, Shimla)'
        : data?.amendments.newAreaLevel === 112
        ? ' (under D.C. Office, ' + data?.district + ')'
        : data?.amendments.newAreaLevel === 113
        ? ' (under SDM Office, ' + data?.district + ')'
        : ''
        }}
      </span>

      by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the said

      <b>{{ data?.societyName }}</b>

      (located at <b>{{ data?.address }}</b>)

      has now been Registered at the

      <b>
        {{
        data?.amendments.newAreaLevel === 111
        ? 'Directorate of Cooperation, Shimla'
        : data?.amendments.newAreaLevel === 112
        ? 'D.C. Office, ' + data?.district
        : data?.amendments.newAreaLevel === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation, Shimla'
        }}
      </b>

      under the Himachal Pradesh Societies Registration Act, 2006
      (Act No. 25 of 2006)

      on the <span [innerHTML]="data?.amendDayText"></span>
      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content underline">

      <i>
        The Certificate issued previously vide No.
        <b>{{ data?.regNo }}</b>
        dated
        <b>{{ data?.regDate }}</b>
        shall be treated as cancelled.
      </i>

    </p>

    <p class="content">

      Given under my hand and seal at

      <b>
        {{
        data?.amendments.newAreaLevel === 111
        ? 'Directorate of Cooperation, Shimla'
        : data?.amendments.newAreaLevel === 112
        ? 'D.C. Office, ' + data?.district
        : data?.amendments.newAreaLevel === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation, Shimla'
        }}
      </b>,

      Himachal Pradesh.

    </p>

    <div class="footer">

      <div></div>

      <div>

        <b>
          {{
          data?.amendments.newAreaLevel === 111
          ? 'Registrar of Societies'
          : data?.amendments.newAreaLevel === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.amendments.newAreaLevel === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>

        <p><b>Himachal Pradesh</b></p>

      </div>

    </div>

  </div>

  <div class="page" *ngIf="data?.amendments?.address && data?.amendments?.area 
&& !data?.amendments?.rules && !data?.amendments?.name && !data?.amendments?.objectives">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.newRegNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.newRegNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Societies</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the

      <b>{{ data?.societyName }}</b>

      (located at <b>{{ data?.oldAddress }}</b>)

      previously registered under the Societies Registration Act, 2006 by the

      <!-- <b>{{ data?.oldAuthority }}</b> -->
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>

      vide Registration No.

      <b>{{ data?.regNo }}</b>

      dated

      <b>{{ data?.regDate }}</b>

      has extended its area of operation from

      <span>
        {{
        data?.oldAreaLevel === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.oldAreaLevel === 112
        ?<b>'District level'</b> ('D.C. Office, ' + data?.district) + 'to'
        <b> {{data?.newAreaLevel}}</b> + (under 'Directorate of Cooperation, Shimla')
        : data?.oldAreaLevel === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + data?.district
        }}
      </span>

      <span>
        {{
        data?.newAreaLevel === 111
        ? <b>'State Level'</b> + ('under Directorate of Cooperation, Shimla')
        : data?.newAreaLevel === 112
        ?<b>'District level'</b> ('under D.C. Office, ' + data?.district)
        : data?.newAreaLevel === 113
        ? <b>'SDM level'</b> ('under SDM Office, ' + data?.district)
        : 'Directorate of Cooperation ,' + data?.district
        }}
      </span>





      <span *ngIf="data?.newAddress">
        and also changed its Address to
        <b>{{ data?.newAddress }}</b>
      </span>


      and Rules and Regulations by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the said

      <b>{{ data?.societyName }}</b>

      (located at <b>{{ data?.newAddress }}</b>)

      has now been Registered at the

      <b>
        {{
        data?.newAreaLevel === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.newAreaLevel === 112
        ?'D.C. Office, ' + data?.district
        : data?.newAreaLevel === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + 'Shimla'
        }}
      </b>

      with the amended Address and Rules and Regulations

      under the Himachal Pradesh Societies Registration Act, 2006
      (Act No. 25 of 2006)

      on the <span [innerHTML]="data?.amendDayText"></span> (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content underline">

      <i>The Certificate issued previously vide No.

        <b>{{ data?.regNo }}</b>

        dated

        <b>{{ data?.regDate }}</b>

        shall be treated as cancelled. </i>

    </p>

    <p class="content">
      Given under my hand and seal at



      <b>
        {{
        data?.newAreaLevel === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.newAreaLevel === 112
        ?'D.C. Office, ' + data?.district
        : data?.newAreaLevel === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + 'Shimla'
        }}
      </b>,

      Himachal Pradesh.
    </p>



    <div class="footer">
      <div></div>
      <div>
        <b>
          {{
          data?.newAreaLevel === 111
          ? 'Registrar of Societies'
          : data?.newAreaLevel === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.newAreaLevel === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>

  </div>
<div class="page"
    *ngIf="data?.amendments?.name && data?.amendments?.rules 
    && !data?.amendments?.address && !data?.amendments?.area  && !data?.amendments?.objectives ">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.regNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Amendment</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the

      <b>{{ data?.amendments?.oldName }}</b>

      ( located at <b>{{ data?.address }}</b>)

      previously registered under the Societies Registration Act, 2006 by the
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>,
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation,' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office,' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation,' + data?.district
        }}
      </b>


      Himachal Pradesh vide Registration No.
      <b>{{ data?.regNo }}</b>
      dated
      <b>{{ data?.regDate }}</b>

      has changed its Name to

      <b>{{ data?.amendments?.newName }}</b>,

      Rules and Regulations by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the said

      <b>{{ data?.amendments?.newName }}</b>

      (located at {{ data?.address }})

      has now been Registered with the amended Name and Rules and Regulations under sub section (2) of
      section 11 of the Himachal Pradesh Societies Registration Act, 2006 (Act No. 25 of 2006)

      on the

      <span [innerHTML]="data?.amendDayText"></span>

      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content underline">

      <i> The Certificate issued previously vide No.

        <b>{{ data?.regNo }}</b>

        dated

        <b>{{ data?.regDate }}</b>

        shall be treated as cancelled. </i>

    </p>

    <p class="content">
      Given under my hand and seal at
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ' + data?.district
        }}
      </b>,
      Himachal Pradesh.
    </p>



    <div class="footer">
      <div></div>

      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>

  </div>
  <div class="page"
    *ngIf="data?.amendments?.name && data?.amendments?.objectives && data?.amendments?.rules 
    && !data?.amendments?.address && !data?.amendments?.area">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.regNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Amendment</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the

      <b>{{ data?.amendments?.oldName }}</b>

      ( located at <b>{{ data?.address }}</b>)

      previously registered under the Societies Registration Act, 2006 by the
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>,
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation,' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office,' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation,' + data?.district
        }}
      </b>


      Himachal Pradesh vide Registration No.
      <b>{{ data?.regNo }}</b>
      dated
      <b>{{ data?.regDate }}</b>

      has changed its Name to

      <b>{{ data?.amendments?.newName }}</b>,

      Objectives and Rules and Regulations by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the said

      <b>{{ data?.amendments?.newName }}</b>

      (located at {{ data?.address }})

      has now been Registered with the amended Name, Objectives and Rules and Regulations under sub section (2) of
      section 11 of the Himachal Pradesh Societies Registration Act, 2006 (Act No. 25 of 2006)

      on the

      <span [innerHTML]="data?.amendDayText"></span>

      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content underline">

      <i> The Certificate issued previously vide No.

        <b>{{ data?.regNo }}</b>

        dated

        <b>{{ data?.regDate }}</b>

        shall be treated as cancelled. </i>

    </p>

    <p class="content">
      Given under my hand and seal at
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ' + data?.district
        }}
      </b>,
      Himachal Pradesh.
    </p>



    <div class="footer">
      <div></div>

      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>

  </div>

   <div class="page"
    *ngIf="data?.amendments?.name && data?.amendments?.objectives && !data?.amendments?.rules 
    && !data?.amendments?.address && !data?.amendments?.area">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.regNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Amendment</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the

      <b>{{ data?.amendments?.oldName }}</b>

      ( located at <b>{{ data?.address }}</b>)

      previously registered under the Societies Registration Act, 2006 by the
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>,
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation,' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office,' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation,' + data?.district
        }}
      </b>


      Himachal Pradesh vide Registration No.
      <b>{{ data?.regNo }}</b>
      dated
      <b>{{ data?.regDate }}</b>

      has changed its Name to

      <b>{{ data?.amendments?.newName }}</b>,

      and Objectives by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the said

      <b>{{ data?.amendments?.newName }}</b>

      (located at {{ data?.address }})

      has now been Registered with the amended Name, and Objectives under sub section (2) of
      section 11 of the Himachal Pradesh Societies Registration Act, 2006 (Act No. 25 of 2006)

      on the

      <span [innerHTML]="data?.amendDayText"></span>

      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content underline">

      <i> The Certificate issued previously vide No.

        <b>{{ data?.regNo }}</b>

        dated

        <b>{{ data?.regDate }}</b>

        shall be treated as cancelled. </i>

    </p>

    <p class="content">
      Given under my hand and seal at
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ' + data?.district
        }}
      </b>,
      Himachal Pradesh.
    </p>



    <div class="footer">
      <div></div>

      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>

  </div>

  <div class="page" *ngIf="data?.amendments?.address && data?.amendments?.rules 
&& !data?.amendments?.objectives && !data?.amendments?.name && !data?.amendments?.area">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.regNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Amendment</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the

      <b>{{ data?.societyName }}</b>

      (located at <b>{{ data?.amendments?.oldAddress }}</b>)

      registered under the Societies Registration Act, 2006 by the
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>,
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office,' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation,' + data?.district
        }}
      </b>,
      Himachal Pradesh vide Registration No.
      <b>{{ data?.regNo }}</b>
      dated
      <b>{{ data?.regDate }}</b>

      has changed its Address to

      <b>{{ data?.amendments?.newAddress }}</b>

      and Rules and Regulations by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the amendment in

      Address and Rules and Regulations of Society

      has been Registered under the Himachal Pradesh Societies Registration Act, 2006
      (Act No. 25 of 2006)

      on the

      <span [innerHTML]="data?.amendDayText"></span>

      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content">
      Given under my hand and seal at
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation,' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office,' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation,' + data?.district
        }}
      </b>,
      Himachal Pradesh.
    </p>



    <div class="footer">
      <div></div>

      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>

  </div>


  <div class="page" *ngIf="data?.amendments?.address && data?.amendments?.objectives 
&& !data?.amendments?.rules && !data?.amendments?.name && !data?.amendments?.area">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.regNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Amendment</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the

      <b>{{ data?.societyName }}</b>

      (located at <b>{{ data?.amendments?.oldAddress }}</b>)

      registered under the Societies Registration Act, 2006 by the
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>,
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation,' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office,' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation, Shimla'
        }}
      </b>,
      Himachal Pradesh vide Registration No.
      <b>{{ data?.regNo }}</b>
      dated
      <b>{{ data?.regDate }}</b>

      has changed its Address to

      <b>{{ data?.amendments?.newAddress }}</b>

      and Objectives by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the amendment in

      Address and Objectives of Society

      has been Registered under the Himachal Pradesh Societies Registration Act, 2006
      (Act No. 25 of 2006)

      on the

      <span [innerHTML]="data?.amendDayText"></span>

      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content">
      <b> Given under my hand and seal at
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation,' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office,' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation, Shimla'
        }}
      </b>,
      Himachal Pradesh.
    </p>



    <div class="footer">
      <div></div>

      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>

  </div>



  <div class="page"
    *ngIf="data?.amendments?.name && data?.amendments?.objectives && data?.amendments?.rules 
    && data?.amendments?.address && !data?.amendments?.area">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.regNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Amendment</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the

      <b>{{ data?.amendments?.oldName }}</b>

     
      (located at <b>{{ data?.amendments?.oldAddress }}</b>)
      previously registered under the Societies Registration Act, 2006 by the
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>,
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation,' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office,' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation,' + data?.district
        }}
      </b>


      Himachal Pradesh vide Registration No.
      <b>{{ data?.regNo }}</b>
      dated
      <b>{{ data?.regDate }}</b>

      has changed its Name to

      <b>{{ data?.amendments?.newName }}</b>,

      and Address to

          <b>{{ data?.amendments?.newAddress }}</b>,
      Objectives and Rules and Regulations by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the said

      <b>{{ data?.amendments?.newName }}</b>

      (located at {{ data?.amendments?.newAddress  }})

      has now been Registered with the amended Name,Address, Objectives and Rules and Regulations under sub section (2) of
      section 11 of the Himachal Pradesh Societies Registration Act, 2006 (Act No. 25 of 2006)

      on the

      <span [innerHTML]="data?.amendDayText"></span>

      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content underline">

      <i> The Certificate issued previously vide No.

        <b>{{ data?.regNo }}</b>

        dated

        <b>{{ data?.regDate }}</b>

        shall be treated as cancelled. </i>

    </p>

    <p class="content">
      Given under my hand and seal at
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ' + data?.district
        }}
      </b>,
      Himachal Pradesh.
    </p>



    <div class="footer">
      <div></div>

      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>

  </div>

    <div class="page" *ngIf="data?.amendments?.rules &&
    data?.amendments?.objectives &&
!data?.amendments?.address &&

!data?.amendments?.name &&
!data?.amendments?.area">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.regNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.regNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Amendment</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-4">
      Himachal Pradesh Societies Registration Act 2006
      <!-- <p>हिमाचल प्रदेश सरकार</p> -->
    </div>

    <p class="content">

      This is certified that the
      <b>{{ data?.societyName }}</b>

      ( located at <b>{{ data?.address }}</b> )

      registered under the Societies Registration Act, 2006 by the
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Registrar of Societies'
        : data?.iAreaOperation === 112
        ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
        : data?.iAreaOperation === 113
        ? 'SDM -cum- Deputy Registrar of Societies'
        : 'Registrar of Societies'
        }}
      </b>
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office, ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + data?.district
        }}
      </b>,
      Himachal Pradesh vide Registration No.
      <b>{{ data?.regNo }}</b>
      dated
      <b>{{ data?.regDate }}</b>

      has changed its Objective and
      Rules and Regulations

      by way of amendments in its Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the amendment in Objectives and
      Rules and Regulations of Society

      has been Registered under the Himachal Pradesh Societies Registration Act, 2006
      (Act No. 25 of 2006)

      on the
      <span [innerHTML]="data?.amendDayText"></span>

      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content">
      Given under my hand and seal at
      <b>
        {{
        data?.iAreaOperation === 111
        ? 'Directorate of Cooperation, ' + 'Shimla'
        : data?.iAreaOperation === 112
        ? 'D.C. Office, ' + data?.district
        : data?.iAreaOperation === 113
        ? 'SDM ' + data?.sSubDivisionName
        : 'Directorate of Cooperation ,' + 'Shimla'
        }}
      </b>,
      Himachal Pradesh.
    </p>

    <div class="footer">
      <div></div>

      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>
    </div>

  </div>
  <div class="page" *ngIf="type == 'AREA_SUBDIVISION_TO_STATE'">

    <div class="reg-barcode-section">

      <div class="reg-container">

        <div class="reg-label">
          <b>Registration No:</b>
        </div>

        <div class="qr-section">

          <qrcode [qrdata]="data?.newRegNo || 'N/A'" [width]="120" [errorCorrectionLevel]="'M'"
            [elementType]="'canvas'">
          </qrcode>

          <div class="reg-value">
            <b>{{ data?.newRegNo }}</b>
          </div>

        </div>

      </div>

    </div>

    <h2 class="title">Certificate of Registration of Societies</h2>

    <div class="logo-section">
      <img src="../../../assets/images/logos/hplogo.png" />
    </div>

    <div class="center bold title mt-2">
      Himachal Pradesh Societies Registration Act 2006
      <p>हिमाचल प्रदेश सरकार</p>
    </div>

    <p class="content">

      This is certified that the

      <b>{{ data?.societyName }}</b>

      (located at <b>{{ data?.oldAddress }}</b>)

      previously registered under the Societies Registration Act, 2006 by the

      <b>
        SDM cum Deputy Registrar of Societies,
        {{ data?.oldOffice }},
        Himachal Pradesh
      </b>

      vide Registration No.

      <b>{{ data?.oldRegNo }}</b>

      dated

      <b>{{ data?.oldRegDate }}</b>

      has extended its area of operation from

      <b>
        Sub Divisional Level
        (under {{ data?.oldOffice }})
      </b>

      to

      <b>
        State Level
        (under Directorate of Cooperation, SHIMLA)
      </b>

      and also changed its Address to

      <b>{{ data?.newAddress }}</b>,

      Objectives and Rules and Regulations by way of amendments in its
      Memorandum of Association and Bye-Laws.

    </p>

    <p class="content">

      It is further certified that the said

      <b>{{ data?.societyName }}</b>

      (located at <b>{{ data?.newAddress }}</b>)

      has now been Registered at the

      <b>State Level</b>

      with the amended

      <b>Address, Objectives and Rules and Regulations</b>

      under the Himachal Pradesh Societies Registration Act, 2006
      (Act No. 25 of 2006)

      on the

      <span [innerHTML]="data?.amendDayText"></span>

      (<b>{{ data?.amendDate }}</b>).

    </p>

    <p class="content">

      The Certificate issued previously vide No.

      <b>{{ data?.oldRegNo }}</b>

      dated

      <b>{{ data?.oldRegDate }}</b>

      shall be treated as cancelled.

    </p>

    <p class="content">
      Given under my hand and seal at

      <b>
        Directorate of Cooperation, SHIMLA
      </b>,

      Himachal Pradesh.
    </p>

    <div class="note-section">

      <p>
        <b>Only Incorporation Certificate</b>
      </p>

      <p>
        The Society shall not start any activities such as admission of
        students, starting of Training Institutions / Schools or any
        developmental function etc. without approval from concerned
        State Government Departments / Statutory Bodies.
      </p>

    </div>

    <div class="footer">

      <div></div>

      <div>
        <b>
          {{
          data?.iAreaOperation === 111
          ? 'Registrar of Societies'
          : data?.iAreaOperation === 112
          ? 'Deputy Commissioner -cum- Additional Registrar of Societies'
          : data?.iAreaOperation === 113
          ? 'SDM -cum- Deputy Registrar of Societies'
          : 'Registrar of Societies'
          }}
        </b>
        <p><b>Himachal Pradesh</b></p>
      </div>

    </div>

  </div>





</div>
<button class="btn btn-primary btn-sm">


  <a target="_blank" (click)="downloadCertificate()" class="btn btn-primary btn-sm">
    <i class="fa fa-print"></i>
  </a>

</button>